export const CONVERSATIONAL_CHAT_SESSION = 'mijn-conversational.chat-session';
export const NBA_SESSION = 'nba';
export const OVERBOEKEN_SESSION = 'overboeken';

export const ANALYTICS_PHONE_VALIDATION_ELEMENT = 'Telefoonnummer-validatie';
export const ANALYTICS_PHONE_VALIDATION_ACTION_VALIDATE = 'telefoonnummer bevestigen';
export const ANALYTICS_PHONE_VALIDATION_ACTION_CHANGE = 'telefoonnummer aanpassen';
export const ANALYTICS_PHONE_VALIDATION_ACTION_NEW = 'telefoonnummer doorgeven';
